/**
 * Add rotation ability to a model
 */
import { TYPE, EVENTSTATUS, SEATSTATUS, RENDERER_MODE } from '@/constants';
import SVG from 'svg.js';
import Matrix from '../Matrix';
import Application from '../application';

// type SelectableMixing2<T extends { new (...args: any[]): SelectableRequirements }> = InstanceType<
//   ReturnType<typeof SelectableMixin<T>>
// >;

export interface RotatableRequirements {
  attributes: Record<string, any>;
  view: SVG.G;
  app: Application;
  type: (typeof TYPE)[keyof typeof TYPE];
  moveShapes(x: number, y: number): void;
}

export const RotatableMixin = <T extends { new (...args: any[]): RotatableRequirements }>(base: T) => {
  return class RotatableMixin extends base {
    matrix: SVG.Matrix | undefined;

    checkIfRotatable() {
      if (!this.app.props.options.modes.map((s) => s.toLowerCase()).includes('drawing')) return false;
      let rotatable = true;
      if (this.type === TYPE.SEAT || this.type === TYPE.TABLE || this.type === TYPE.TABLESEAT) {
        if (this.app.props.status === EVENTSTATUS.PUBLISHED) {
          rotatable = false;
        }
      }
      return rotatable;
    }

    onRotateStart() {
      if (this.checkIfRotatable()) {
        this.matrix = this.view.transform('matrix' as any) as unknown as SVG.Matrix;
      }
    }

    onRotateMove(rm: SVG.Matrix) {
      if (this.checkIfRotatable()) {
        this.view.transform(rm.multiply(this.matrix!) as any);
      }
    }

    onRotateEnd() {
      if (this.checkIfRotatable()) {
        if (this.type === TYPE.SEAT) {
          const p = this.attributes.position;
          const { x, y } = new SVG.Point(p).transform(this.view.transform('matrix' as any) as unknown as SVG.Matrix);
          const [oldX, oldY] = this.attributes.position;
          this.attributes.position = [x, y];
          this.attributes.rotation = this.attributes.rotation || 0;
          this.attributes.rotation += new Matrix(this.view).decompose(oldX, oldY).rotate;
          this.moveShapes(x, y);
          this.view.untransform();
        }
        delete this.matrix;
      }
    }

    rotate(angle: number, cx: number, cy: number, relative = false) {
      if (this.checkIfRotatable()) {
        this.view.transform({ rotation: angle, cx, cy }, relative);
      }
    }
  };
};
